<template>
  <GmapMarker
      v-if="position && text && shouldShow"
      :position="position"
      :clickable="false"
      :icon="iconSpec"
      :z-index="6"
  />
</template>

<script>
import { Marker as GmapMarker } from 'vue2-google-maps';

const FREE_BORDER = '#0B5D55';
const FREE_FILL = '#E8F6F4';
const RESERVED_BORDER = '#7E0F0F';
const RESERVED_FILL = '#FFFFFF';

export default {
  name: 'MarketPolygonLabel',
  components: { GmapMarker },

  props: {
    position: { type: Object, default: null },
    pricingMode: { type: String, default: 'calculated' },
    ownerName: { type: String, default: '' },
    // Current map zoom + the per-market threshold below which the label
    // would visually exceed the polygon it's annotating. When omitted,
    // default to "always show" so existing callers keep working.
    currentZoom: { type: Number, default: null },
    labelZoom: { type: Number, default: null },
  },

  computed: {
    shouldShow() {
      if (typeof this.currentZoom !== 'number' || typeof this.labelZoom !== 'number') {
        return true;
      }
      return this.currentZoom >= this.labelZoom;
    },
    isFree() {
      return this.pricingMode === 'free';
    },
    text() {
      if (this.isFree) {
        return (this.ownerName || '').trim() || 'RESERVED';
      }
      return 'RESERVED';
    },
    iconSpec() {
      // Render the label as a pill-shaped SVG so it's readable against the
      // polygon's pink/teal fill. White background + colored border + bold
      // uppercase text + a leading dot icon.
      const border = this.isFree ? FREE_BORDER : RESERVED_BORDER;
      const fill = this.isFree ? FREE_FILL : RESERVED_FILL;
      const text = this.text.toUpperCase();
      const charWidth = 7.2;
      const padding = 28;
      const dotWidth = 16;
      const width = Math.max(96, Math.round(text.length * charWidth + padding + dotWidth));
      const height = 24;
      const r = height / 2;
      const dotCx = 14;
      const textX = dotCx + 9;
      const svg = `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
  <rect x="0.75" y="0.75" width="${width - 1.5}" height="${height - 1.5}" rx="${r}" ry="${r}" fill="${fill}" stroke="${border}" stroke-width="1.5"/>
  <circle cx="${dotCx}" cy="${height / 2}" r="3.5" fill="${border}"/>
  <text x="${textX}" y="${height / 2 + 4}" font-family="Lato, system-ui, sans-serif" font-size="11" font-weight="700" fill="${border}" letter-spacing="0.5">${text}</text>
</svg>`;
      const url = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
      return {
        url,
        scaledSize: { width, height },
        anchor: { x: width / 2, y: height / 2 },
      };
    },
  },
};
</script>
